module.exports = __webpack_public_path__ + "img/keitaro-landing-step-7.ru.d20a2822.jpg";